import type { GivingBase } from 'models';
import { DataCard, Icon } from 'ui';
import { images } from 'common/utils';
import { useGivingCardContent } from './hooks';

type P = {
  getPathToGivingDetail: (id: string) => string;
  giving: GivingBase;
  showTag?: boolean;
};

const GivingCard = ({ getPathToGivingDetail, giving, showTag = true }: P) => {
  const { description, participantsProperties, pricesProperties, progressProperties, tagLabel } = useGivingCardContent({
    giving,
  });

  return (
    <DataCard
      className="giving-card"
      description={description}
      image={{
        alt: 'Giving cover image',
        src: giving.coverPhoto?.url ?? images.default.givingCoverPhoto,
      }}
      participantsProperties={participantsProperties}
      path={getPathToGivingDetail(giving.id)}
      pricesProperties={pricesProperties}
      progressProperties={progressProperties}
      tag={showTag ? { children: tagLabel, color: 'orange-dark', icon: <Icon icon="hand-heart-line" /> } : undefined}
      title={giving.name}
    />
  );
};

export default GivingCard;
